<template>
	<div>
		<div class="page f-c-sc">
			<div class="path">
				首页 - 企业申报 - 企业申报指南
			</div>
			<Spin :spinning="loading">
				<div class="policy f-c-sc">
					<div class="head  f-c-sc" v-if="policy.policyName">
						<div class="policyName">
							{{ policy.policyName || "" }}
						</div>

						<div class="label">
							<div class="label-item" v-if="policy.ranges">{{ policy.ranges }}</div>
							<div class="label-item" v-if="policy.policyArea">{{ policy.policyArea }}</div>
							<div class="label-item" v-if="policy.policySubsidy">{{ policy.policySubsidy }}万元</div>
							<div v-if="policy.policyName && userInfo" class="label-item" :style="{ color: '#E21F1F', background: 'rgba(226, 31, 31, 0.1)' }" @click="throttle(changeCollect(),300)">
								{{ policy.isCollect == 1 ? "已关注" : "未关注" }}
							</div>
						</div>

						<div class="time">{{ policy.hasStartTime || "" }}</div>
					</div>

					<div class="policy-content" v-html="policy.content"></div>

					<!-- 政策数据取到时 且个人信息存在时 可以 申报 -->
					<Button v-if="policy.policyName && userInfo && status != 'look' && policyType != '2'" type="primary" class="toDeclare" @click="toDeclare">去申报</Button>
				</div>
			</Spin>
		</div>
	</div>
</template>

<script>
import { Message } from "ant-design-vue";
import { getAction } from "@/util/require.js";
import lodash from "lodash";
const { throttle } = lodash;
export default {
	name: "",
	components: {},
	data() {
		const userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null;
		return {
			id: "",
			status: "",
			policyType: "",
			policy: {},
			loading: false,

			userInfo,
		};
	},
	created() {
		this.id = this.$route.query.itemId;
		this.status = this.$route.query.status;
		this.policyType = this.$route.query.policyType;
		this.getPolicyById();
	},
	mounted() {},
	watch: {
		$route: {
			handler(newVal, oldVal) {
				this.id = newVal.query.itemId;
				this.getPolicyById();
			},
			deep: true,
		},
	},
	methods: {
		throttle,
		toDeclare() {
			this.$router.push({ path: "/declare", query: { itemId: this.id } });
		},
		getPolicyById() {
			this.loading = true;
			getAction("/hq/webPage/queryPolicyListById", {
				id: this.id,
			})
				.then((res) => {
					if (res.success) {
						this.policy = res.result;
					} else {
						Message.error(res.message);
					}
				})
				.finally((res) => {
					this.loading = false;
				});
		},
		changeCollect() {
			if (this.policy.isCollect == 1) {
				getAction("/hq/webPage/deleteCollect", {
					id: this.id,
				}).then((res) => {
					if (res.success) {
						Message.success(res.message);
						this.getPolicyById();
					} else {
						Message.error(res.message);
					}
				});
			} else {
				getAction("/hq/webPage/createPolicyCollect", {
					id: this.id,
				}).then((res) => {
					if (res.success) {
						Message.success(res.message);
						this.getPolicyById();
					} else {
						Message.error(res.message);
					}
				});
			}
		},
	},
};
</script>

<style scoped lang="scss">
.page {
	box-sizing: border-box;
	min-height: 1000px;
	padding: 60px 0 0 0;
	width: 1200px;
}

.path {
	width: 100%;
	font-size: 16px;
	font-weight: 400;
	color: #333333;
	text-indent: 30px;
}

.policy {
	width: 1200px;
	min-height: 1000px;
	.head {
		padding: 60px 0 30px;
		position: relative;
		width: 100%;
		border-bottom: 1px solid #e5e5e5;
		.policyName {
			width: 1080px;
			font-size: 30px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #333333;
			text-align: center;
			line-height: 1.3;
		}
		.label {
			margin-top: 28px;
			display: flex;
			flex-direction: row;
			align-items: center;
			.label-item {
				font-size: 16px;
				font-weight: 400;
				color: #1f82e2;
				padding: 0 14px;
				height: 30px;
				line-height: 30px;
				background: rgb(31, 130, 226, 0.1);
				border-radius: 2px;
				margin: 0 5px;
				cursor: pointer;
			}
		}
		.time {
			font-size: 16px;
			font-weight: 400;
			color: #999999;
			position: absolute;
			right: 88px;
			bottom: 38px;
		}
	}
	.policy-content {
		width: 1095px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 30px;
		text-indent: 2em;
		line-height: 1.5;
		margin: 37px 0 59px 0;
	}
	.toDeclare {
		font-size: 24px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #fefefe;
		width: 200px;
		height: 50px;
		margin: 0 0 114px;
		border-radius: 4px;
		letter-spacing: 2px;
	}
}
</style>
